import { render, staticRenderFns } from "./CouponItem.vue?vue&type=template&id=e29797b2&scoped=true&lang=pug&"
import script from "./CouponItem.vue?vue&type=script&lang=js&"
export * from "./CouponItem.vue?vue&type=script&lang=js&"
import style0 from "./CouponItem.vue?vue&type=style&index=0&id=e29797b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29797b2",
  null
  
)

export default component.exports